var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiPersona(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "ai-persona_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ai-persona_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#A9E1E7",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.879 15.2c14.778 0 20.716 21.669 8.652 31.215-1.201.947-.514 2.866 1.015 2.866v.008c11.54 0 21.41 8.154 21.411 19.125v21.911H8.8v-21.91c0-10.972 9.872-19.126 21.412-19.126.9 0 1.636-.72 1.636-1.62 0-1.772-2.806-1.805-5.382-7.384-5.16-11.141 1.84-25.085 13.413-25.085z",
    fill: "url(#ai-persona_svg__paint0_linear_10323_68463)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-persona_svg__paint0_linear_10323_68463",
    x1: 8.8,
    y1: 90.325,
    x2: 85.024,
    y2: 34.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60F3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#00CCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009AC0"
  })))));
}
export default __webpack_public_path__ + "fonts/ai-persona-8c732f64653af72560fc522ced0e9906.svg";
export { SvgAiPersona as ReactComponent };